import React from 'react'
import { Create, SimpleForm, TextInput, required } from 'react-admin'

export default props => (
  <Create {...props}>
    <SimpleForm redirect='/node/firm'>
      <TextInput source='attributes.title' validate={required()} />
      <TextInput fullWidth multiline source='attributes.body.value' />
    </SimpleForm>
  </Create>
)
